import React from "react";

// ISO 3166-1 alpha-2 -> emoji flag
export function flagEmoji(code) {
  if (!code) return "🏳️";
  return code.toUpperCase().replace(/./g, c =>
    String.fromCodePoint(127397 + c.charCodeAt(0))
  );
}

// Use circle-flags (already circular SVG). Special-case "EN"/"SCT".
export function FlagCircle({ code, size = 48, logoUrl }) {
  if (!code) {
    return <div className="flag-circle" style={{ width: size, height: size }} />;
  }
  if (logoUrl) {
    return (
      <div className="flag-circle" style={{ width: size, height: size }}>
        <img src={logoUrl} alt="" className="object-contain" loading="lazy" decoding="async" />
      </div>
    );
  }
  const c = String(code).toLowerCase();
  const key = c === "en" ? "gb-eng" : c === "sct" ? "gb-sct" : c;
  const url = `/vendor/circle-flags/flags/${key}.svg`;
  return (
    <div className="flag-circle" style={{ width: size, height: size }}>
      <img src={url} alt={code} loading="lazy" decoding="async" />
    </div>
  );
}
